module.exports = __webpack_public_path__ + "media/views/about/images/icons/faq_6-b5ff6b3ae0dd18fa6ba62a36c00eda63.svg";